import React from "react";
import * as BoxModule from "@mui/material/Box/index.js";
import { resolveDefault } from "../../utils/moduleInterop";

const Box = resolveDefault<any>(BoxModule);

interface BlankFieldProps {}

const BlankField: React.FC<BlankFieldProps> = (props) => {
	return <Box></Box>;
};

export default BlankField;
